export enum TicketTypeEnum {
  PAID = "PAID",
  FREE = "FREE"
}
